// @flow

export const ButtonTypes = {
  URL: 'url',
  POSTBACK: 'postback',
  OPEN_CHAT: 'open_chat',
  MAYBE_LATER: 'maybe_later',
  EXIT: 'exit',
  POSITIVE_FEEDBACK: 'positive-feedback',
  NEGATIVE_FEEDBACK: 'negative-feedback'
}
